import { useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalAddFaq.css";
import { contentService } from "../../services/content.service";
import { closeModal, showModal } from "../../utils/functions/modal";

const ModalAddFaq = ({ setMessage, onSuccess }) => {
  const [titulo, setTitulo] = useState("");
  const [respuesta, setRespuesta] = useState("");
  const [orden, setOrden] = useState(0);

  const clearInputs = () => {
    setTitulo("");
    setRespuesta("");
    setOrden(0);
  };

  const handleSubmitFaq = async (e) => {
    e.preventDefault();

    closeModal(".container-modal-add-faq");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Agregando pregunta...",
      status: 1000,
    });

    const response = await contentService.addFaq({
      titulo: titulo.trim(),
      respuesta: respuesta.trim(),
      orden: parseInt(orden) || 0,
    });

    setTimeout(() => {
      if (response.data.status === 200) {
        clearInputs();
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1000);
  };

  return (
    <div className="container-modal container-modal-add-faq">
      <div className="modal modal-add-faq">
        <div className="header-modal">
          <h3>Agregar Pregunta Frecuente</h3>
          <button onClick={() => closeModal(".container-modal-add-faq")}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <form onSubmit={handleSubmitFaq} className="body-modal">
          <div className="input">
            <label htmlFor="tituloAddFaq">Pregunta</label>
            <input
              type="text"
              id="tituloAddFaq"
              name="tituloAddFaq"
              required
              onChange={(e) => setTitulo(e.target.value)}
              value={titulo}
              placeholder="¿Cuál es el tiempo de demora estimado?"
            />
          </div>
          <div className="input">
            <label htmlFor="respuestaAddFaq">Respuesta</label>
            <textarea
              id="respuestaAddFaq"
              name="respuestaAddFaq"
              required
              onChange={(e) => setRespuesta(e.target.value)}
              value={respuesta}
              placeholder="Escribí la respuesta completa"
              rows={5}
            />
          </div>
          <div className="input">
            <label htmlFor="ordenAddFaq">Orden</label>
            <input
              type="number"
              id="ordenAddFaq"
              name="ordenAddFaq"
              onChange={(e) => setOrden(e.target.value)}
              value={orden}
              min={0}
            />
            <span className="hint">Determina el orden en que se muestra en la web (menor primero)</span>
          </div>

          <button className="btn-add-product">AGREGAR PREGUNTA</button>
        </form>
      </div>
    </div>
  );
};

export default ModalAddFaq;
